var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitHubMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 560,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with ImageTracer.java version 1.1.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 0",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0.5 0.0 L 560.0 0.5 L 559.5 560.0 L 0.0 559.5 L 0.5 0.0 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 0",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 75.0 L 265.0 75.5 L 261.5 76.0 L 261.5 75.0 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 0",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 75.0 L 269.0 75.5 L 265.5 76.0 L 265.5 75.0 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 0",
    fill: "rgb(23,21,21)",
    stroke: "rgb(23,21,21)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 269.5 75.0 L 290.0 75.5 L 310.0 77.5 L 332.5 82.0 L 344.5 85.0 Q 368.0 92.5 387.0 104.5 Q 417.8 122.2 440.0 148.5 Q 457.6 168.9 470.0 194.5 L 481.0 223.5 L 485.0 239.5 L 489.0 262.5 L 490.0 292.5 Q 487.5 294.0 489.0 299.5 L 487.0 318.5 Q 480.0 359.0 461.5 388.0 Q 446.0 415.5 423.5 436.0 Q 398.5 460.0 364.0 474.5 L 351.5 479.0 Q 348.0 482.5 340.5 482.0 L 334.0 478.5 Q 330.0 473.5 332.0 462.5 L 332.0 426.5 L 332.0 410.5 L 331.0 401.5 Q 328.9 385.1 319.0 376.5 L 324.5 375.0 L 342.5 372.0 Q 374.8 364.8 393.0 343.5 Q 406.0 328.5 411.0 305.5 L 413.0 291.5 L 414.0 280.5 L 414.0 263.5 L 411.5 252.0 Q 409.3 239.7 403.0 231.5 L 396.0 221.5 L 394.0 218.5 L 393.0 214.5 L 395.5 206.0 L 396.0 201.5 L 397.0 189.5 L 396.0 186.5 L 395.5 180.0 Q 394.4 168.6 389.5 161.0 L 381.5 161.0 L 376.5 162.0 L 366.5 165.0 L 349.5 172.0 L 337.0 179.5 Q 335.0 183.0 328.5 182.0 L 316.5 179.0 L 297.0 176.5 L 262.5 176.0 L 251.5 178.0 L 238.5 180.0 L 233.5 181.0 L 227.5 183.0 L 205.5 170.0 L 193.5 165.0 L 183.5 162.0 Q 178.4 159.6 169.5 161.0 Q 164.4 169.4 163.0 181.5 L 162.0 196.5 L 166.0 217.5 Q 156.1 227.1 151.0 241.5 Q 146.2 250.2 145.5 263.0 L 145.0 286.5 L 149.0 308.5 Q 155.5 336.5 174.5 352.0 Q 189.2 364.8 211.0 370.5 L 240.0 376.5 Q 232.0 383.5 229.0 395.5 L 228.0 400.5 L 226.5 404.0 Q 215.6 410.1 197.5 409.0 Q 180.8 405.7 172.0 394.5 Q 166.1 382.5 156.5 374.0 L 146.0 367.5 Q 140.0 363.5 128.5 365.0 L 124.0 368.5 L 128.5 375.0 Q 139.1 380.4 146.0 389.5 L 154.5 405.0 Q 158.8 417.7 168.5 425.0 Q 178.1 432.9 193.5 435.0 L 207.5 436.0 Q 208.8 433.8 213.5 435.0 L 226.5 433.0 L 227.0 474.5 L 223.5 480.0 Q 220.6 482.6 214.5 482.0 Q 159.0 463.5 124.0 424.5 Q 103.9 403.1 90.5 375.0 Q 79.6 355.4 74.5 330.0 L 71.5 314.0 L 70.0 299.5 L 69.0 274.5 Q 71.5 273.0 70.0 267.5 L 72.5 247.0 Q 79.5 206.0 99.0 177.5 Q 115.7 147.2 141.5 126.0 Q 160.1 109.6 183.5 98.0 L 211.0 86.5 L 226.5 82.0 L 245.5 78.0 L 262.5 76.0 Q 268.0 77.5 269.5 75.0 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 1",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 290.5 75.0 L 294.0 75.5 L 290.5 76.0 L 290.5 75.0 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 1",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 75.0 L 298.0 75.5 L 294.5 76.0 L 294.5 75.0 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 2",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 76.0 L 305.0 76.5 L 302.5 77.0 L 302.5 76.0 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 3",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 116.0 L 152.5 118.0 L 153.5 116.0 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 4",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 405.5 116.0 L 406.5 118.0 L 405.5 116.0 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 5",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 119.0 L 148.5 121.0 L 149.5 119.0 Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 6",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 409.5 119.0 L 410.5 121.0 L 409.5 119.0 Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 2",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 122.0 L 144.5 124.0 L 145.5 122.0 Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 3",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 413.5 122.0 L 414.5 124.0 L 413.5 122.0 Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 7",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 124.0 L 142.5 126.0 L 143.5 124.0 Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 8",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 415.5 124.0 L 416.5 126.0 L 415.5 124.0 Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 4",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 127.0 L 136.5 131.0 L 139.5 127.0 Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 5",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 419.5 127.0 L 422.5 131.0 L 419.5 127.0 Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 9",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 131.0 L 124.5 143.0 L 135.5 131.0 Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 10",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 423.5 131.0 L 434.5 143.0 L 423.5 131.0 Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 6",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 143.0 L 120.5 147.0 L 123.5 143.0 Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 7",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 435.5 143.0 L 438.5 147.0 L 435.5 143.0 Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 11",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 149.0 L 117.5 151.0 L 118.5 149.0 Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 12",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 440.5 149.0 L 441.5 151.0 L 440.5 149.0 Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 8",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 151.0 L 115.5 153.0 L 116.5 151.0 Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 9",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 442.5 151.0 L 443.5 153.0 L 442.5 151.0 Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 10",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 156.0 L 111.5 158.0 L 112.5 156.0 Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 11",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 446.5 156.0 L 447.5 158.0 L 446.5 156.0 Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 12",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 160.0 L 108.5 162.0 L 109.5 160.0 Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 13",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 449.5 160.0 L 450.5 162.0 L 449.5 160.0 Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 13",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 262.5 176.0 L 265.0 176.5 L 262.5 177.0 L 262.5 176.0 Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 14",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 176.0 L 270.0 176.5 L 265.5 177.0 L 265.5 176.0 Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 15",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 176.0 L 294.0 176.5 L 289.5 177.0 L 289.5 176.0 Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 14",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 176.0 L 297.0 176.5 L 294.5 177.0 L 294.5 176.0 Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 15",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 177.0 L 255.0 177.5 L 252.5 178.0 L 252.5 177.0 Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 16",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 304.5 177.0 L 307.0 177.5 L 304.5 178.0 L 304.5 177.0 Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 17",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 182.0 L 333.0 182.5 L 330.5 183.0 L 330.5 182.0 Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 18",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 189.0 L 163.0 196.5 L 162.0 196.5 L 162.5 189.0 Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 19",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 189.0 L 397.0 196.5 L 396.0 196.5 L 396.5 189.0 Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 16",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 217.0 L 165.5 219.0 L 166.5 217.0 Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 17",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392.5 217.0 L 394.5 220.0 L 392.5 217.0 Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 20",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 219.0 L 163.5 221.0 L 164.5 219.0 Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 21",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 258.0 L 71.0 260.5 L 70.0 260.5 L 70.5 258.0 Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 22",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 488.5 258.0 L 489.0 260.5 L 488.0 260.5 L 488.5 258.0 Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 23",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 263.0 L 146.0 265.5 L 145.0 265.5 L 145.5 263.0 Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 24",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 413.5 263.0 L 414.0 265.5 L 413.0 265.5 L 413.5 263.0 Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 18",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 265.0 L 70.0 268.5 L 69.0 268.5 L 69.5 265.0 Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 19",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 489.5 265.0 L 490.0 268.5 L 489.0 268.5 L 489.5 265.0 Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 20",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 266.0 L 146.0 281.5 L 145.0 281.5 L 145.5 266.0 Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 21",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 413.5 266.0 L 414.0 281.5 L 413.0 281.5 L 413.5 266.0 Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 25",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 269.0 L 70.0 273.5 L 69.0 273.5 L 69.5 269.0 Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 26",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 489.5 269.0 L 490.0 273.5 L 489.0 273.5 L 489.5 269.0 Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 27",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 282.0 L 146.0 286.5 L 145.0 286.5 L 145.5 282.0 Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 28",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 413.5 282.0 L 414.0 286.5 L 413.0 286.5 L 413.5 282.0 Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 22",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 291.0 L 147.0 293.5 L 146.0 293.5 L 146.5 291.0 Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 23",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 412.5 291.0 L 413.0 293.5 L 412.0 293.5 L 412.5 291.0 Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 29",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 293.0 L 70.0 297.5 L 69.0 297.5 L 69.5 293.0 Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 30",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 489.5 293.0 L 490.0 297.5 L 489.0 297.5 L 489.5 293.0 Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 24",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 298.0 L 70.0 301.5 L 69.0 301.5 L 69.5 298.0 Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 25",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 489.5 298.0 L 490.0 301.5 L 489.0 301.5 L 489.5 298.0 Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 31",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 306.0 L 71.0 308.5 L 70.0 308.5 L 70.5 306.0 Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 32",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 488.5 306.0 L 489.0 308.5 L 488.0 308.5 L 488.5 306.0 Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 33",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 343.0 L 168.5 346.0 L 166.5 343.0 Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 34",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392.5 343.0 L 390.5 346.0 L 392.5 343.0 Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 26",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 346.0 L 172.5 350.0 L 169.5 346.0 Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 27",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 346.0 L 387.5 349.0 L 389.5 346.0 Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 35",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 349.0 L 384.5 352.0 L 386.5 349.0 Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 36",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 350.0 L 174.5 352.0 L 173.5 350.0 Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 28",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 353.0 L 178.5 355.0 L 177.5 353.0 Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 37",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 354.0 L 379.5 356.0 L 380.5 354.0 Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 38",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 371.0 L 128.5 375.0 L 125.5 371.0 Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 1",
    fill: "rgb(23,21,21)",
    stroke: "rgb(23,21,21)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 371.0 L 149.0 373.5 L 148.5 375.0 L 144.0 374.5 L 143.0 372.5 L 144.5 371.0 Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 29",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 371.0 L 148.5 373.0 L 147.5 371.0 Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 39",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 374.0 L 161.5 380.0 L 156.5 374.0 Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 40",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 375.0 L 239.0 375.5 L 236.5 376.0 L 236.5 375.0 Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 30",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 375.0 L 241.0 375.5 L 238.5 379.0 L 239.5 375.0 Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 41",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 375.0 L 321.0 375.5 L 319.0 376.5 L 321.5 380.0 L 319.0 377.5 Q 316.8 376.3 319.5 375.0 Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 2",
    fill: "rgb(23,21,21)",
    stroke: "rgb(23,21,21)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 378.0 L 157.0 380.5 L 158.0 382.5 L 154.5 384.0 Q 151.5 383.5 152.0 379.5 L 153.5 378.0 Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 42",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 379.0 L 236.5 381.0 L 237.5 379.0 Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 31",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 380.0 L 138.5 382.0 L 137.5 380.0 Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 43",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 382.0 L 142.5 386.0 L 139.5 382.0 Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 44",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 382.0 L 153.5 384.0 L 152.5 382.0 Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 32",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 386.0 L 144.5 388.0 L 143.5 386.0 Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 3",
    fill: "rgb(23,21,21)",
    stroke: "rgb(23,21,21)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 389.0 Q 165.5 388.5 166.0 391.5 L 165.5 396.0 Q 161.8 396.8 161.0 394.5 L 160.0 390.5 L 161.5 389.0 Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 33",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 389.0 L 165.5 391.0 L 164.5 389.0 Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 34",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 391.0 L 170.5 393.0 L 169.5 391.0 Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 4",
    fill: "rgb(23,21,21)",
    stroke: "rgb(23,21,21)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 401.0 L 177.0 403.5 L 176.5 408.0 L 171.0 406.5 L 170.0 402.5 L 171.5 401.0 Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 35",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 401.0 L 180.5 403.0 L 179.5 401.0 Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 36",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 406.0 L 332.0 409.5 L 331.0 409.5 L 331.5 406.0 Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 37",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 408.0 L 111.5 410.0 L 110.5 408.0 Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 38",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 448.5 408.0 L 447.5 410.0 L 448.5 408.0 Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 39",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 409.0 L 205.0 409.5 L 202.5 410.0 L 202.5 409.0 Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 5",
    fill: "rgb(23,21,21)",
    stroke: "rgb(23,21,21)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 410.0 Q 191.0 409.0 192.0 412.5 L 190.5 416.0 Q 185.4 416.6 184.0 413.5 L 185.5 410.0 Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 40",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 410.0 L 224.0 410.5 L 220.5 411.0 L 220.5 410.0 Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 6",
    fill: "rgb(23,21,21)",
    stroke: "rgb(23,21,21)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 411.0 L 225.0 411.5 L 226.0 413.5 L 220.5 417.0 L 217.0 414.5 L 219.5 411.0 Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 41",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 412.0 L 207.0 412.5 L 204.5 413.0 L 204.5 412.0 Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 45",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 413.0 L 193.0 414.5 L 191.0 415.5 L 192.5 413.0 Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 7",
    fill: "rgb(23,21,21)",
    stroke: "rgb(23,21,21)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 413.0 Q 209.0 412.0 210.0 415.5 L 208.5 418.0 L 205.5 419.0 L 201.0 416.5 L 201.5 414.0 L 203.5 413.0 Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 46",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 208.5 413.0 L 209.5 415.0 L 208.5 413.0 Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 47",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 414.0 L 116.5 416.0 L 115.5 414.0 Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 48",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 414.0 L 224.5 416.0 L 225.5 414.0 Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 49",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 443.5 414.0 L 442.5 416.0 L 443.5 414.0 Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 50",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 417.0 L 162.5 419.0 L 161.5 417.0 Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 42",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 440.5 418.0 L 438.5 421.0 L 440.5 418.0 Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 43",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 419.0 L 120.5 421.0 L 119.5 419.0 Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 44",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 419.0 L 166.5 423.0 L 163.5 419.0 Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 51",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 421.0 L 123.5 424.0 L 121.5 421.0 Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 52",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 437.5 421.0 L 435.5 424.0 L 437.5 421.0 Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 53",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 423.0 L 168.5 425.0 L 167.5 423.0 Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 45",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 214.5 434.0 L 217.0 434.5 L 214.5 435.0 L 214.5 434.0 Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 54",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 435.0 L 208.0 435.5 L 201.5 436.0 L 201.5 435.0 Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 55",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 436.0 L 138.5 439.0 L 136.5 436.0 Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 56",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 422.5 436.0 L 419.5 440.0 L 422.5 436.0 Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 46",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 439.0 L 141.5 442.0 L 139.5 439.0 Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 47",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 418.5 440.0 L 417.5 442.0 L 418.5 440.0 Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 57",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 443.0 L 145.5 445.0 L 144.5 443.0 Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 58",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 414.5 443.0 L 413.5 445.0 L 414.5 443.0 Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 48",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 445.0 L 147.5 447.0 L 146.5 445.0 Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 49",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 412.5 445.0 L 411.5 447.0 L 412.5 445.0 Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    desc: "l 13 p 59",
    fill: "rgb(120,119,119)",
    stroke: "rgb(120,119,119)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 447.0 L 150.5 449.0 L 149.5 447.0 Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 50",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 452.0 L 228.0 472.5 L 227.0 472.5 L 227.5 452.0 Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    desc: "l 11 p 51",
    fill: "rgb(155,154,154)",
    stroke: "rgb(155,154,154)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 453.0 L 332.0 472.5 L 331.0 472.5 L 331.5 453.0 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHubMark);
export default __webpack_public_path__ + "static/media/GitHub-Mark.35ed54bc921b73b2446f4b716055061d.svg";
export { ForwardRef as ReactComponent };